import axios from "axios";
import { store } from "../redux/store/store";
import { logoutUser } from "../redux/reducer/authReducer/AuthReducer";
import { clearAuthData } from "../utils/helpers";
import { LOGIN } from "../routes/RouteConstant";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_SSR || "/api",
  timeout: 20000,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const skipAuthRedirect = error?.config?.skipAuthRedirect;
    if (error?.response?.status === 401 && !skipAuthRedirect) {
      clearAuthData();
      store.dispatch(logoutUser());
      if (window.location.pathname !== LOGIN) {
        window.location.href = LOGIN;
      }
    }
    return Promise.reject(error);
  },
);

export default api;